"use strict"; // https://html.spec.whatwg.org/multipage/window-object.html#browser-interface-elements

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BarPropImpl = function BarPropImpl() {
  _classCallCheck(this, BarPropImpl);
}; // Since many BarProps do not apply to modern browsers,
// returning true in all cases seems to be common practice.


BarPropImpl.prototype.visible = true;
exports.implementation = BarPropImpl;